/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendOpexVariantDto } from '../../models/backend-opex-variant-dto';

export interface SalesOpexVariantsList$Params {
  is_blocked?: boolean;
  product_varinat?: number;
  project?: number;
  variant_name?: string;
}

export function salesOpexVariantsList(
  http: HttpClient,
  rootUrl: string,
  params?: SalesOpexVariantsList$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<Array<BackendOpexVariantDto>>> {
  const rb = new RequestBuilder(rootUrl, salesOpexVariantsList.PATH, 'get');
  if (params) {
    rb.query('is_blocked', params.is_blocked, {});
    rb.query('product_varinat', params.product_varinat, {});
    rb.query('project', params.project, {});
    rb.query('variant_name', params.variant_name, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<Array<BackendOpexVariantDto>>;
    }),
  );
}

salesOpexVariantsList.PATH = '/api/sales/opex_variants/';
